<template>
  <v-container fluid class="px-0 py-0">
    <template v-if="summary">
      <div class="base-info">
        <em class="em">以下数据为定时统计结果，可能存在延迟。</em>
        <!--
        <label>联系人:</label> <em>{{ summary.contact || "无" }}</em>
        <label>联系电话:</label> <em>{{ summary.tel || "无" }}</em>
        -->
        <label>统计时间:</label>
        <em>{{ summary.lastStatTime | formatDatetime }}</em>
      </div>
      <v-divider />
      <v-layout row wrap>
        <v-flex xm12 sm4 md3>
          <v-card class="panel panel-1" :color="colors[0]" dark>
            <v-card-text>
              <v-icon :size="40" class="left-icon">person</v-icon>
              <div>
                <em>{{ summary.etotalStuCount || 0 }}</em><label>在岗</label><br />
                <em>{{ (summary.totalStuCount - summary.etotalStuCount) || 0 }}</em>
                <label>离职</label><br /><em>{{ summary.totalStuCount || 0 }}</em>
                <label>总共</label>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xm12 sm4 md3 v-if="summary.orgCount">
          <v-card class="panel panel-1" :color="colors[1]" dark>
            <v-card-text>
              <v-icon :size="40" class="left-icon">domain</v-icon>
              <div>
                <em>{{ summary.epCount || 0 }}</em><label>企业</label><br />
                <em>{{ summary.orgCount }}</em>
                <label>直属机构</label>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xm12 sm4 md3>
          <v-card class="panel panel-1" :color="colors[2]" dark>
            <v-card-text>
              <v-icon :size="40" class="left-icon">computer</v-icon>
              <div>
                <em>{{ summary.totalStuClazzCount || 0 }}</em><label>培训课次</label><br />
                <em>{{ summary.totalClazzCount || 0 }}</em>
                <label>培训计划</label>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-card v-if="accTypesSummary && accTypesSummary.yAxis.data.length > 1" class="panel panel-2">
        <v-chart autoresize :option="accTypesSummary" :style="{
          height: 35 + accTypesSummary.yAxis.data.length * 35 + 'px',
        }" />
      </v-card>
      <v-card class="panel" v-if="clazzes && clazzes.length > 0">
        <v-card-title primary-title>本月培训情况</v-card-title>
        <v-card-text>
          <div v-for="c in clazzes" :key="c.id" style="margin-bottom: 8px">
            <v-divider />
            <clazz-chart :clazzId="c.id" :hideOrgList="true" :hideTitle="false" :hideStepSummary="true"
              style="margin: 16px 0" />
          </div>
        </v-card-text>
      </v-card>
    </template>
  </v-container>
</template>
<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart, BarChart } from "echarts/charts";

import {
  TitleComponent,
  TooltipComponent,
  ToolboxComponent,
  GridComponent,
} from "echarts/components";

import VChart from "vue-echarts";

import ClazzChart from "./clazz-chart.vue";

use([
  CanvasRenderer,
  PieChart,
  BarChart,
  TitleComponent,
  TooltipComponent,
  ToolboxComponent,
  GridComponent,
]);
export default {
  name: "tenant-dash",
  components: {
    "v-chart": VChart,
    "clazz-chart": ClazzChart,
  },
  data() {
    return {
      summary: null,
      colors: this.$colors,
      clazzes: null,
      accTypesSummary: null,
    };
  },
  methods: {
    init() {
      let self = this;
      self.$axios.get("/home/my/tenant/org/get").then((r) => {
        let s = r.data.message;
        self.summary = s;
        if (s.globalStuCountTypeHash) {
          let hash = JSON.parse(s.globalStuCountTypeHash),
            keys = Object.keys(hash);
          if (keys.length > 0) {
            let types = {};
            for (let o of r.data.types) {
              types[o.id] = o.name;
            }
            let accTypesSummary = {
              title: {
                subtext: "人员按类型分布 {tip|该图表基于人员类型设置统计，存在一人多职情况}", subtextStyle: {
                  rich: {
                    tip: { color: "orange", fontSize: "10px" },
                  },
                }
              },
              label: { show: true, position: "right" },
              tooltip: { show: true },
              grid: {
                top: 40,
                bottom: 30, //距离容器下边界30像素
                right: 30,
                left: 100
              },
              toolbox: {
                show: true,
                feature: {
                  saveAsImage: { show: true },
                },
              },
              yAxis: {
                type: "category",
                data: [],
              },
              xAxis: {
                type: "value",
              },
              series: [
                {
                  data: [],
                  type: "bar"
                },
              ],
            };
            let i = 0;
            for (let k of keys) {
              accTypesSummary.yAxis.data.push({
                value: types[k],
                textStyle: {
                  fontSize: 10,
                  overflow: "truncate",
                  ellipsis: "...",
                }
              });
              accTypesSummary.series[0].data.push({
                value: hash[k],
                itemStyle: {
                  borderRadius: [0, 10, 10, 0],
                  color: self.colors[i++]
                }
              });
            }
            self.accTypesSummary = accTypesSummary;
          }
        }
      });

      //列出5个当月份培训计划并生成图表
      let month = self.$formatDate(Date.now()).substring(0, 7);
      function getClasses() {
        return self.$axios.get(
          `/home/admin/my/tenant/clazz/search/0/2?month=${month}`
        );
      }
      function getGClasses() {
        return self.$axios.get(
          `/home/admin/my/tenant/clazz/search/0/2?_global=true&month=${month}`
        );
      }
      self.$axios.all([getClasses(), getGClasses()]).then(
        self.$axios.spread(function (d1, d2) {
          self.clazzes = [...d1.data.message, ...d2.data.message];
        })
      );
    },
  },
  created() {
    this.init();
  },
};
</script>
<style scoped>
.echart {
  width: 100%;
}

.base-info {
  text-align: right;
  padding: 8px;
  font-size: 12px;
}

.base-info label {
  color: gray;
  margin-left: 8px;
}

.base-info .em {
  color: darkorange;
}

.v-chart {
  height: 300px;
}

.panel {
  margin: 8px;
}

.left-icon {
  float: left;
  margin-bottom: 40px;
  margin-right: 8px;
}

.panel-1 {
  min-height: 90px;
}

.panel-2 {
  padding: 8px;
}

.panel-1 div label {
  padding: 0 4px;
  font-size: 10px;
}

.panel-1 div .val {
  font-size: 12px;
}

.panel-1 div em {
  font-size: 14px;
}
</style>
